import { NavLink } from 'react-router-dom'
import '../header.css'
import NavLinks from './nav-links'

function Nav() {
    return (
        <nav>
            <NavLinks/>
        </nav>
    )
}

export default Nav
